export default __webpack_public_path__ + "static/media/32.682db85d.jpg";